import { connect } from 'react-redux';
import NetsuiteView from './NetsuiteView.jsx';
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import { authorizeAccount, authorizeAccountByIntegration, authenticateAccount, fetchNetsuiteIntegration } from 'src/legacy/redux/actions/integrations/netsuite.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'netsuite');

  return {
    url: state.legacyRootReducer.settings.integrations.netsuite.authorization.url,
    integration: integration,
    user: state.users.me,
    authenticating:state.legacyRootReducer.settings.integrations.netsuite.authentication.authenticating,
    errors: state.legacyRootReducer.settings.integrations.netsuite.authentication.error,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    authorizeAccount: (clientId, clientSecret) => {
      return dispatch(authorizeAccount(clientId, clientSecret));
    },

    authorizeAccountByIntegration: (integrationId) => {
      return dispatch(authorizeAccountByIntegration(integrationId));
    },

    authenticateAccount: (code, company, entity, clientId, clientSecret)=> {
      return dispatch(authenticateAccount(code, company, entity, clientId, clientSecret));
    },

    fetchNetsuiteIntegration: () =>{
      return dispatch(fetchNetsuiteIntegration())
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const NetsuitePage = connect (
    mapStateToProps,
    mapDispatchToProps
)(NetsuiteView);

export default withUseHooks(NetsuitePage);
